import {Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {TtLiveActivityEntry} from '../../interfaces/time-tracking/tt-live-activity-entry';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {TtLiveActivityEntryFactory} from '../../factories/time-tracking/tt-live-activity-entry-factory';

@Injectable({
  providedIn: 'root'
})
export class TtLiveActivityEntriesTable extends SyncTable<TtLiveActivityEntry> {
  constructor() {
    super(db.ttLiveActivityEntries);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<TtLiveActivityEntry>({
        api: ['tt-live-activity-entries'],
        fromObject: TtLiveActivityEntryFactory.fromObject,
        toRemote: TtLiveActivityEntryFactory.toRemote
      })
    };
  }

  public async removeAll(): Promise<void> {
    const ttLiveActivityEntries = await this.getAll();
    await this.removeMany(ttLiveActivityEntries.map(_ttLiveActivityEntry => _ttLiveActivityEntry.uuid));
  }

  public async replace(ttLiveActivityEntry: TtLiveActivityEntry): Promise<TtLiveActivityEntry> {
    this._lockChangeTrigger = true;
    let newTtLiveActivityEntry: TtLiveActivityEntry;
    try {
      newTtLiveActivityEntry = await db.transaction('rw', db.syncStatusItems, this.table, async () => {
        const ttLiveActivityEntries = await this.getAll();
        await this.removeMany(ttLiveActivityEntries.map(_ttLiveActivityEntry => _ttLiveActivityEntry.uuid));
        return await this.add(ttLiveActivityEntry);
      });
    }
    finally {
      this._lockChangeTrigger = false;
    }
    this.triggerChange();
    return newTtLiveActivityEntry;
  }

  public async removeDuplicates(): Promise<void> {
    const ttLiveActivityEntries = await this.getAll();
    if(ttLiveActivityEntries.length <= 1) {
      return;
    }

    const sortedTtLiveActivityEntries = [...ttLiveActivityEntries].sort((firstEntry, secondEntry) => {
      const createdComparison = (secondEntry.created ?? '').localeCompare(firstEntry.created ?? '');
      return createdComparison !== 0 ? createdComparison : secondEntry.uuid.localeCompare(firstEntry.uuid);
    });
    await this.removeMany(sortedTtLiveActivityEntries.slice(1).map(ttLiveActivityEntry => ttLiveActivityEntry.uuid));
  }
}
